import AccountCredit from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/AccountCredit/AccountCredit';

export default AccountCredit;
